import apiFetch from '../apiFetch'
export default function (token, conditionNoDocumentalId) {
  return apiFetch({ endPoint: `conditionNoDocumental/${conditionNoDocumentalId}`, method: 'DELETE', body: null, token: token })
}
